export enum copilotCard {
  SUGGESTION = 'suggestion',
  INFORMATION = 'information',
  SENTIMENT = 'sentiment',
  FLOW = 'flow',
  TRANSFER = 'transfer',
}

export const copilotCardAgents = [
  {
    msgType: copilotCard.INFORMATION,
    message:
      'To Transfer this interaction, here is a list of most suited agent candidates:',
    showIcon: true,
    isSelectedAsQuickReply: false,
  },
  {
    msgType: copilotCard.TRANSFER,
    message: 'Remy Sharp',
    imgSrc: './assets/RemySharp.jpg',
    showIcon: true,
    buttonCaption: 'Transfer',
  },
  {
    msgType: copilotCard.TRANSFER,
    message: 'Travis Howard',
    imgSrc: './assets/TravisHoward.jpg',
    showIcon: true,
    buttonCaption: 'Transfer',
  },
  {
    msgType: copilotCard.TRANSFER,
    message: 'Cindy Baker',
    imgSrc: './assets/CindyBaker.jpg',
    showIcon: true,
    buttonCaption: 'Transfer',
  },
];

export const copilotCardMockDataForChat = [
  {
    msgType: copilotCard.SUGGESTION,
    suggestionLabel: 'Suggested Question:',
    message:
      'Have you been removing your clothing items as soon as possible when the wash cycle is complete? This can help prevent mildew and odor buildup.',
    showIcon: true,
    isSelectedAsQuickReply: false,
  },
  {
    msgType: copilotCard.SENTIMENT,
    sentiment: 'dummy',
    message: 'dummy bypass msg',
    showIcon: true,
  },
  {
    msgType: copilotCard.SENTIMENT,
    sentiment: 'Neutral',
    message: 'Customer Sentiment is improving',
    showIcon: true,
  },
  {
    msgType: copilotCard.SUGGESTION,
    suggestionLabel: 'Suggested Prompt:',
    message:
      'To eliminate odor from your washer, run the Clean Washer cycle every month or every 30 cycles using affresh® washer cleaner or liquid chlorine bleach. \n\n Additionally, always leave the washer lid or door open between uses and use warm/hot wash water settings occasionally.',
    showIcon: true,
    isSelectedAsQuickReply: false,
  },
  {
    msgType: copilotCard.SENTIMENT,
    sentiment: 'dummy',
    message: 'dummy bypass msg',
    showIcon: true,
  },
  {
    msgType: copilotCard.SENTIMENT,
    sentiment: 'Positive',
    message: 'Customer Sentiment is positive',
    showIcon: true,
  },
];

export interface copilotAutoSummaryData {
  overallSummaryRating: string;
  lastContact: string;
  sentiment: string;
  contactReason: string;
  outcome: string;
  events: Array<any>;
  additionalNotes: string;
}

export const foulSmellAutoSummaryData: copilotAutoSummaryData = {
  overallSummaryRating: 'Positive',
  lastContact: '2 minutes ago',
  sentiment: 'Positive',
  contactReason:
    'Foul smell in washing machine \n Etching on glassware in dishwasher',
  outcome: 'Completed',
  events: [
    { eventSource :'customer', eventText:'Customer reported a foul smell in washing machine and etching on glassware.'},
    { eventSource :'agent', eventText:'Agent recommended ideas for how to use and how to eliminate odor, and how to prevent etching.'},
    { eventSource :'agent', eventText:'Agent scheduled tech to review usage and installation of products.'},
  ],
  additionalNotes:
    'Customer reported a foul smell. Agent provided a link as well as some information for how best to use the washer. Customer also had etching on their glassware from the dishwasher. Agent scheduled tech to review usage and installation of products.',
};

export const copilotCardMockDataForVideoCall = [
  {
    msgType: copilotCard.INFORMATION,
    message:
      'Customer redirected from ONE travel mobile application. Customer reported damaged luggage',
    showIcon: true,
    isSelectedAsQuickReply: false,
  },
  {
    msgType: copilotCard.INFORMATION,
    isSelectedAsQuickReply: false,
    message: 'Client flew from DEN to SEA. Bags arrived damaged',
    showIcon: true,
  },
  {
    msgType: copilotCard.SENTIMENT,
    sentiment: 'Positive',
    message: 'Show Empathy',
    showIcon: true,
  },
  {
    msgType: copilotCard.FLOW,
    message: 'Reimbursement Claim',
    showIcon: false,
    buttonCaption: 'Start',
  },
  {},
  {},
  {},
  {
    msgType: copilotCard.INFORMATION,
    message: 'Processing claim',
    showIcon: true,
    isSelectedAsQuickReply: false,
  },
  {
    msgType: copilotCard.INFORMATION,
    message: 'Claim is approved. Claim has been sent to liam.davis@gmail.com',
    showIcon: true,
    isSelectedAsQuickReply: false,
  },
  {
    msgType: copilotCard.SENTIMENT,
    sentiment: 'Positive',
    message: 'Thank for Loyalty',
    showIcon: true,
  },
  {
    msgType: copilotCard.SUGGESTION,
    suggestionLabel: 'Suggested Prompt:',
    message: 'Damaged Luggage Article',
    showIcon: true,
    isSelectedAsQuickReply: false,
  },
];

export const damagedLuggageAutoSummaryData: copilotAutoSummaryData = {
  overallSummaryRating: 'Positive',
  lastContact: '2 minutes ago',
  sentiment: 'Positive',
  contactReason: 'Damaged Luggage',
  outcome: 'Claim was approved',
  events: [
    { eventSource :'agent', eventText:'Bags arrived damaged'},
    { eventSource :'agent', eventText:'Open damaged luggage claim'},
    { eventSource :'agent', eventText:'Claim Approved'},
    { eventSource :'agent', eventText:'Sent suggested knowledge article'},
    { eventSource :'agent', eventText:'Schedule follow up'},
  ],
  additionalNotes:
    'After flying from DEN to SEA, the client discovered that their bags had arrived damaged. They completed a claim to report the issue and the claim was approved. They were sent an article describing the claim process.',
};

export interface chatSuggestion {
  msgType: string;
  message: string;
  sentiment?: string;
  suggestionLabel?: string;
  isSelectedSuggestion?: boolean;
  imageSrc?: string;
  isMsgEditable?: boolean;
  isResponseTextbox?: boolean;
  articleContent?: string;
  showArticleContentAslink?: boolean;
}

export enum msgType {
  SUGGESTION = 'suggestion',
  INFORMATION = 'information',
  ARTICLE = 'article',
}

export const SuggestionCardChatData: chatSuggestion[][] = [
  [
    {
      msgType: msgType.INFORMATION,
      message: 'What kinds of issues are you having?',
      isMsgEditable: false,
    },
    {
      msgType: msgType.SUGGESTION,
      suggestionLabel: 'Suggested Empathy Response',
      message: 'I’m sorry to hear that. What types of issues are you having?',
      sentiment: 'Neutral',
      isMsgEditable: false,
    },
    {
      msgType: 'information',
      message: '',
      isResponseTextbox: true,
      isMsgEditable: false,
    },
  ],
  [
    {
      msgType: msgType.INFORMATION,
      message: 'Let’s work together to get this resolved.',
      isMsgEditable: false,
    },
    {
      msgType: msgType.SUGGESTION,
      suggestionLabel: 'Suggested Empathy Response',
      message:
        'I’m sorry to hear that. Let’s work together to get this resolved.',
      sentiment: 'Neutral',
      isMsgEditable: false,
    },
    {
      msgType: 'information',
      message: '',
      isResponseTextbox: true,
      isMsgEditable: false,
    },
  ],
  [
    {
      msgType: msgType.INFORMATION,
      message: 'Here is an article that can help.',
      isMsgEditable: false,
    },
    {
      msgType: msgType.SUGGESTION,
      suggestionLabel: 'Suggested ownership Response',
      message: 'I’m sorry to hear that. Here is an article that can help',
      sentiment: 'Neutral',
      isMsgEditable: false,
    },
    {
      msgType: 'information',
      message: '',
      isResponseTextbox: true,
      isMsgEditable: false,
    },
  ],
  [
    {
      msgType: msgType.INFORMATION,
      message: 'What is going on with the second appliance?',
      isMsgEditable: false,
    },
    {
      msgType: msgType.SUGGESTION,
      suggestionLabel: 'Suggested Empathy Response',
      message:
        'Can you please tell me about the issue you’re having with the second appliance?',
      sentiment: 'Positive',
      isMsgEditable: false,
    },
  ],
  [
    {
      msgType: msgType.INFORMATION,
      message: 'Here is an article that can help',
      isMsgEditable: false,
    },
    {
      msgType: msgType.SUGGESTION,
      suggestionLabel: 'Suggested ownership Response',
      message: 'I’m sorry to hear that. Here is an article that can help',
      sentiment: 'Neutral',
      isMsgEditable: false,
    },
  ],
  [
    {
      msgType: msgType.INFORMATION,
      message:
        'Would you like any more articles on filming and etching on glassware?',
      isMsgEditable: false,
    },
    {
      msgType: msgType.INFORMATION,
      message: 'Is there anything else I can help you with today?',
      isMsgEditable: false,
    },
  ],
  [
    {
      msgType: msgType.INFORMATION,
      message: 'Here is an article that can help',
      isMsgEditable: false,
    },
    {
      msgType: msgType.SUGGESTION,
      suggestionLabel: 'Suggested ownership Response',
      message: 'I’m sorry to hear that. Here is an article that can help',
      sentiment: 'Neutral',
      isMsgEditable: false,
    },
  ],
  [
    {
      msgType: msgType.INFORMATION,
      message: 'Would you like any more articles on loading a dishwasher?',
      isMsgEditable: false,
    },
    {
      msgType: msgType.INFORMATION,
      message: 'Is there anything else I can help you with today?',
      isMsgEditable: false,
    },
  ],
  [
    {
      msgType: msgType.INFORMATION,
      message: 'You’re welcome! Thank you for your business.',
      isMsgEditable: false,
    },
    {
      msgType: 'information',
      message: '',
      isResponseTextbox: true,
      isMsgEditable: false,
    },
  ],
];

export interface copilotAppSpaceCard {
  isArticle: boolean;
  articleHaveLink?: boolean;
  articleTitle: string;
  isArticleSent: boolean;
  articleContent?: string;
  articleShortContent?: string;
  isEditEnabled?: boolean;
}

export const copilotAppSpaceCardData: copilotAppSpaceCard[] = [
  {
    isArticle: true,
    articleTitle: 'What can help with foul smells?',
    articleContent:
      'Foul smells coming from your washing machine can be caused by a number of things including residue buildup, dampness, or even mold. To eliminate the odor, one suggestion is to run a hot water cycle with a mixture of vinegar and baking soda. \n\n Another option would be to try a washing machine cleaner which can help to break up and remove any built-up residue. It is also recommended to leave the door open when the machine is not in use to allow air to circulate.',
    articleShortContent:
      'Foul smells coming from your washing machine can be caused by a number of things including residue buildup, dampness,',
    isArticleSent: false,
    isEditEnabled: false,
  },
  {
    isArticle: true,
    articleTitle: 'Filming and Etching on Glassware',
    articleHaveLink: true,
    articleContent: 'Filming and Etching on Glassware',
    articleShortContent: '',
    isArticleSent: false,
    isEditEnabled: false,
  },
  {
    isArticle: true,
    articleTitle: 'How to load a OneAppliance Dishwasher',
    articleContent:
      'Tips on how to properly load a OneAppliance dishwasher: \n 1) Load dishes at an angle, especially plastic items. \n 2) Use the upper rack for bowls and cups, and the lower rack for plates, cups, and utensils. \n 3) Ensure all cups are face-down and plates are slotted into the rack on their side. \n 4) Be sure that items in the dishwasher do not block the spray arms and detergent dispenser. \n 5) Run hot water in the sink closest to the dishwasher before running the dishwasher.For more information, please visit our website.',
    articleShortContent:
      'Tips on how to properly load a OneAppliance dishwasher: \n 1) Load dishes at an angle, especially plastic items. \n 2) Use the upper rack for bowls...',
    isArticleSent: false,
    isEditEnabled: false,
  },
];
